import { __require as requireParser } from '../node_modules/@messageformat/parser/lib/parser.mjs';

var parserExports = requireParser();

export { parserExports as p };
//# sourceMappingURL=parser.mjs.map
